import { useEffect, useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { CssBaseline } from '@mui/material';

console.log('✅ App.tsx loaded');

// Screens
import SplashScreen from './screens/SplashScreen';
import WelcomeScreen from './screens/auth/WelcomeScreen';
import AuthNavigator from './navigation/AuthNavigator';
import MainNavigator from './navigation/MainNavigator';
import { AuthProvider, useAuth } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { ThemeProvider } from './context/ThemeContext';
// 已移除 SEOHead 的使用

// 内部组件，使用AuthContext
function AppContent() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 极简路由逻辑：loading -> SplashScreen，根路径 -> WelcomeScreen，有user -> MainNavigator，无user -> AuthNavigator
  if (loading) {
    console.log('⏳ App.tsx: 加载中，显示启动页 (loading:', loading, ')');
    return <SplashScreen />;
  }

  // 如果是根路径，直接显示WelcomeScreen，不管用户登录状态
  if (location.pathname === '/') {
    console.log('🏠 App.tsx: 根路径访问，显示欢迎页面');
    return (
      <UserProvider>
        <WelcomeScreen />
      </UserProvider>
    );
  }

  if (user) {
    console.log('👤 App.tsx: 用户已登录，渲染主界面', user.email);
    return (
      <UserProvider>
        <MainNavigator />
      </UserProvider>
    );
  }

  console.log('👤 App.tsx: 用户未登录，渲染认证界面 (user:', user, ')');
  return (
    <UserProvider>
      <AuthNavigator />
    </UserProvider>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
